<!-- eslint-disable vue/valid-template-root -->
<script>
import { ref } from "vue";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import accounting from "accounting-js"
// import _ from "lodash";
import { scroller } from "vue-scrollto/src/scrollTo";
import clientConfig from "/src/config/foresters-financial";
import ToolTip from "./helpers/ToolTip.vue";
import NumInput from "./helpers/NumInput.vue";
import { GetDefaultInputs, RunProjection } from 'investment-projection-engine';
import CoinGraph from "./CoinGraph.vue";

import Highcharts from "highcharts";
import accessibility from "highcharts/modules/accessibility";
accessibility(Highcharts);
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBTabs,
  MDBTabNav,
  MDBTabContent,
  MDBTabItem,
  MDBTabPane,
  MDBBtn,
  MDBAccordion,
  MDBAccordionItem,
  MDBTable,
} from "mdb-vue-ui-kit";

const hasAnyPoints = function(points) {
  let sum = 0;
  for (let point of Array.from(points)) {
    sum += point.y;
  }
  return sum > 0;
}

const formatMoney = function(amount) {
  return accounting.formatMoney(amount, { precision: 0 });
}

export default {
  name: "ResultPanel",

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBTabs,
    MDBTabNav,
    MDBTabContent,
    MDBTabItem,
    MDBTabPane,
    MDBBtn,
    MDBAccordion,
    MDBAccordionItem,
    MDBTable,

    NumInput,
    CoinGraph,
    ToolTip,
  },

  setup() {
    const detailsModal = ref(false);
    const graphModal = ref(false);

    return {
      detailsModal,
      graphModal,
    };
  },

  data() {
    return {
      clientConfig,
      activeTabId: "result1-1",
      projectionTime: "finalYearProjection",
      engineResults: {},

      accordion: {
        one: null,
      },

      balanceChartOptions: {
        accessibility: {
          keyboardNavigation: {
            focusBorder: {
              style: {
                lineWidth: 3,
                color: "#aa1111",
                borderRadius: 5,
              },
              margin: 4,
            },
          },
        },

        chart: {
          // type: "area",
          spacingTop: 20,
          spacingBottom: 0,
          spacingLeft: 20,
          spacingRight: 30,
        },
        title: {
          text: "",
        },
        credits: { enabled: false },
        colors: ["#d9d9d6", "#63666a", "#ff712b"],
        plotOptions: {         
          series: {
            groupPadding: 2,
            marker: {
              enabled: false
            },
            events: {
              legendItemClick: function() {
                return false;
              }
            }
          }
        },

        xAxis: {
          title: {
            text: "Investment year",
          },
          categories: [],
          lineWidth: 1,

          plotLines: [{
            color: 'black', // Color value
            dashStyle: 'ShortDot', // Style of the plot line. Default to solid
            value: 300, // Value of where the line will appear
            width: 2, // Width of the line   
            zIndex: 5, 
            
            label: {
              text: 'Income plan start', // Content of the label. 
              align: 'left', // Positioning of the label. 
              x: +10, // Amount of pixels the label will be repositioned according to the alignment. 
              style: {
                fontWeight: 'bold'
              },
            }
            },{
              color: 'black', // Color value
              dashStyle: 'ShortDot', // Style of the plot line. Default to solid
              value: 300, // Value of where the line will appear
              width: 2, // Width of the line    
              zIndex: 5,
              
              label: {
                text: 'Lump sum withdrawal', // Content of the label. 
                align: 'left', // Positioning of the label. 
                x: +10, // Amount of pixels the label will be repositioned according to the alignment. 
                style: {
                  fontWeight: 'bold'
                },
              }
          },]
        },

        yAxis: {
          lineWidth: 1,
          allowDecimals: false,
          gridLineDashStyle: "ShortDot",
          min: 0,

          title: {
            text: "Balance",
            align: "high",
            offset: 0,
            rotation: 0,
            y: -20,
          },
          plotLines: [{
            color: 'black', // Color value
            dashStyle: 'ShortDot', // Style of the plot line. Default to solid
            value: 0, // Value of where the line will appear
            width: 0, // Width of the line   
            zIndex: 5, 
            
            label: {
              text: 'Required funeral fund', // Content of the label. 
              align: 'left', // Positioning of the label. 
              x: +10, // Amount of pixels the label will be repositioned according to the alignment. 
              style: {
                fontWeight: 'bold',
                color: 'transparent',
              },
            }
          }],

          labels: {
            formatter: function () {
              return formatMoney(this.value);
            },
          },
        },

        legend: {
          useHTML: true,
          title: {
            text: '<div style="width: 315px; text-align: center;">Balance comparison</div>'
          },
          align: "center",
          verticalAlign: "bottom",
          y: 0,
          x: 0,
          floating: false,
          backgroundColor: "white",
          borderColor: "none",
          borderWidth: 0,
          shadow: false,
          margin: 10,
        },

        //Mock data
        series: [
          {
            type: 'area',
            name: "Your bond",
            data: [],
            fillColor: {
              linearGradient: {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 1
              },
              stops: [
                [0, '#d9d9d6'],
                [0.8, this.hexToRgba('#d9d9d6', 0)]
              ]
            }
          },
          {
            type: 'spline',
            name: "Managed fund",
            data: [],
            fillColor: {
              linearGradient: {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 1
              },
              stops: [
                [0, Highcharts.getOptions().colors[1]],
                [0.8, this.hexToRgba(Highcharts.getOptions().colors[1], 0)]
              ]
            }
          },
          {
            type: 'spline',
            name: "Term deposit",
            data: [],
            fillColor: {
              linearGradient: {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 1
              },
              stops: [
                [0, Highcharts.getOptions().colors[2]],
                [0.8, this.hexToRgba(Highcharts.getOptions().colors[2], 0)]
              ]
            }
          },
        ],

        tooltip: {
          enabled: true,
          backgroundColor: 'rgba(0, 0, 0, 0)',
          shared: true,
          useHTML: true,
          borderWidth: 0,
          shadow: false,
          hideDelay: 0,

          style: {
            padding: '0px'
          },
          
          formatter() {
            if (hasAnyPoints(this.points)) {
              //console.log("balanceChartOptions - data -", this.points);
              const includePartner = false; //IncludePartner;
              let str = "<div class='highchart-tooltip'>";
              str += `<h3>Year ${this.x}</h3>`;
              str += "<table>";

              for (let p of Array.from(this.points)) {
                if (p.y !== 0) {
                  str += "<tr>";
                  str += "  <td>";
                  str += `    <div class='key' style='background-color: ${p.series.color};'></div>`;
                  str += "  </td>";
                  str += "  <td>";
                  str += `    ${p.series.name}:`;
                  str += "  </td>";
                  str += "  <td>";
                  str += `    ${formatMoney(p.y)}`;
                  str += "  </td>";
                  str += "</tr>";
                }
              }

              if (includePartner) {
                str += "  <tr class='sum'>";
                str += "    <td></td>";
                str += "    <th>Total: </th>";
                str += `    <th>${formatMoney(this.points[0].total)}</th>`;
                str += "  </tr>";
              }
              str += "</table>";
              str += "</div>";
              return str;
            } else {
              return false;
            }
          }
        },
      },
    };
  },

  computed: {
    ...mapGetters([
      "debugMode",
      "analyticsPageNames",
      "activeTab",
      "lastActiveTab",
      
      "data",
      "resultsFieldsValid",
      "incomePlanFieldsValid",

      "priceInflation",
      "wageInflation",
      "assetFee",
      "selectedInvestmentReturnRate",

      "typeOfInvestor",
      "typeOfBond",
      "availableInvestmentOptions",

      "startingDepositMinimum",
      "startingDepositMaximum",
      
      "makeRegularContributions",
      "extraContributions",
      "extraContributionFrequency",
      "extraContributionFrequencyFraction",
      "incomePlanContributionFrequencyFraction",
      "userDefinedInvestmentReturnRate"
    ]),

    ...mapFields([
      "customInvestmentReturnRate",
      "userDefinedInvestment",
      "enabledIncomePlan",
      "startingDeposit",
      "investmentTerm",
      "grossIncome",
      "requiredFuneralFund",
      "targetSavingDuration",
      "investmentRisk",
      "extraContributionsRateOfIncrease",
      "incomePlanStart",
      "incomePlanLumpSumWithdrawal",
      "incomePlanLumpSumWithdrawalYear",
      "incomePlanContributions",
      "incomePlanContributionFrequency",
    ]),

    formFieldWatcher() {
      return [
        //this.enabledIncomePlan, 
        // Don't validate the income plan on open - but will need a watcher to trigger a calculation if all fields are valid

        this.grossIncome,
        this.extraContributionsRateOfIncrease,
        this.investmentRisk,
        this.investmentTerm,
        this.startingDeposit,

        this.requiredFuneralFund,
        this.targetSavingDuration,

        this.incomePlanContributions,
        this.incomePlanLumpSumWithdrawal,
        this.incomePlanLumpSumWithdrawalYear,
        this.incomePlanStart,
        this.incomePlanContributionFrequency,

        this.wageInflation,
        this.priceInflation,
        this.assetFee,
      ];
    },

    coinGraphTotals() {
      const vals = {
        investmentTermYear: null,

        estValue: null,
        estValueAtYearNumber: null,
        taxSavingsValue: null,
        taxSavingsAtYearNumber: null,

        investmentEarnings: null,

        estValueManagedFund: null,
        estValueTermDeposit: null,

        finalEstValue: null,
        finalEstValueManagedFund: null,
        finalEstValueTermDeposit: null,
        
        finalEstValueAtYearNumber: null,        
        finalTaxSavingsValue: null,
        finalTaxSavingsAtYearNumber: null,

        capitalGainsTaxPayableAtEndManagedFund: null,
        capitalGainsTaxPayableAtYearManagedFund: null,
        capitalGainsTaxPayableAtYear10ManagedFund: null,

        // moved from funeralBondData
        funeralBalanceAtEndPresentValueYearAttainedBond: null,
        funeralBalanceAtEndPresentValueYearAttainedManagedFund: null,
        funeralBalanceAtEndPresentValueYearAttainedTermDeposit: null,

        funeralBalanceAtEndPresentValueTargetYearBond: null,
        funeralBalanceAtEndPresentValueTargetYearManagedFund: null,
        funeralBalanceAtEndPresentValueTargetYearTermDeposit: null,

        funeralSavingsGoalOnTrack: null,

        funeralYearAttainSavingsGoalBond: null,
        funeralYearAttainSavingsGoalManagedFund: null,
        funeralYearAttainSavingsGoalTermDeposit: null,
        funeralBondEvantuallyReachedSavingsGoal: false,

        funeralCapitalGainsTaxPayableAtYearManagedFund: null,

        currentBalanceAtSelectedWithdrawalYear: null,
        withdrawalYear: null,

        currentBalanceAtSelectedIncomePlanStartYear: null,
        incomePlanStartYear: null,
       
      };

      if ( this.engineResults && this.engineResults.InvestmentBond) {

        vals.withdrawalYear = this.incomePlanLumpSumWithdrawalYear -2;
        vals.currentBalanceAtSelectedWithdrawalYear = this.engineResults.InvestmentBond[vals.withdrawalYear].BalanceAtEnd_PresentValue;

        vals.incomePlanStartYear = this.incomePlanStart -2;
        vals.currentBalanceAtSelectedIncomePlanStartYear = this.engineResults.InvestmentBond[vals.incomePlanStartYear].BalanceAtEnd_PresentValue;

        vals.capitalGainsTaxPayableAtEndManagedFund = this.engineResults.ManagedFund_CapitalGainsTaxPayableAtEnd_PresentValue;
        vals.capitalGainsTaxPayableAtYear10ManagedFund = this.engineResults.ManagedFund[10].CapitalGainsTaxPayableOnTermination_PresentValue;
        vals.investmentTermYear =  this.engineResults.Inputs.InvestmentTerm;

        // this.engineResults
          // .AdditionalDrawingsForCapitalGains_Total
          // .AdditionalDrawingsForCapitalGains_TotalPresentValue
          // .BankSavingsAccount_YearAttainSavingsGoal
          // .Contributions_Total
          // .Contributions_TotalPresentValue
          // .InvestmentBond_YearAttainSavingsGoal
          // .ManagedFund_YearAttainSavingsGoal
          // .TaxSavings_InFirstYear
          // .TaxSavings_Total
          // .TaxSavings_TotalPresentValue

        // this.engineResults.InvestmentBond[i]
          // .AdditionalDrawingsForCapitalGainsTax
          // .BalanceAtEnd
          // .BalanceAtEnd_PresentValue
          // .BalanceAtEndPresentValue
          // .CapitalGainsInYear
          // .ContributionInYear
          // .DrawingInYear
          // .DrawingOfCapitalGains
          // .FeeInYear
          // .GrossInvestmentReturnInYear
          // .IncomeReturnInYear
          // .LumpSumWithdrawalInYear
          // .OtherIncome
          // .ProjectionYear
          // .RetainedCapitalGains
          // .TaxOnInvestmentReturnInYear

        // this.engineResults.TaxSavings[i]
        // single value per array position

        // this.engineResults.ManagedFund[i]
          // .AdditionalDrawingsForCapitalGainsTax
          // .BalanceAtEnd
          // .BalanceAtEnd_PresentValue
          // .BalanceAtEndPresentValue
          // .CapitalGainsInYear
          // .ContributionInYear
          // .DrawingInYear
          // .DrawingOfCapitalGains
          // .FeeInYear
          // .GrossInvestmentReturnInYear
          // .IncomeReturnInYear
          // .LumpSumWithdrawalInYear
          // .OtherIncome
          // .ProjectionYear
          // .RetainedCapitalGains
          // .TaxOnInvestmentReturnInYear

        // this.engineResults.SavingsAccount[i]
          // .AdditionalDrawingsForCapitalGainsTax
          // .BalanceAtEnd
          // .BalanceAtEnd_PresentValue
          // .BalanceAtEndPresentValue
          // .CapitalGainsInYear
          // .ContributionInYear
          // .DrawingInYear
          // .DrawingOfCapitalGains
          // .FeeInYear
          // .GrossInvestmentReturnInYear
          // .IncomeReturnInYear
          // .LumpSumWithdrawalInYear
          // .OtherIncome
          // .ProjectionYear
          // .RetainedCapitalGains
          // .TaxOnInvestmentReturnInYear

        if (this.typeOfBond === 1) {
          if (this.engineResults.InvestmentBond.length > 10) {
            vals.estValue = this.engineResults.InvestmentBond[8].BalanceAtEnd_PresentValue;
            vals.estValueAtYearNumber = this.engineResults.InvestmentBond[8].ProjectionYear;

            vals.estValueManagedFund = this.engineResults.ManagedFund[8].BalanceAtEnd_PresentValue;
            vals.estValueTermDeposit = this.engineResults.SavingsAccount[8].BalanceAtEnd_PresentValue;

            vals.taxSavingsValue = 0;
            for (let i = 0; i < 10; i++) {
              vals.taxSavingsValue += this.engineResults.TaxSavings[i];
            }
            vals.taxSavingsAtYearNumber = this.engineResults.InvestmentBond[8].ProjectionYear;

            if (this.enabledIncomePlan && this.incomePlanFieldsValid) {
              vals.investmentEarnings = this.engineResults.InvestmentEarningsYoY_PresentValue[this.incomePlanStart - 2];
              vals.finalEstValue = this.engineResults.InvestmentBond[this.incomePlanStart - 2].BalanceAtEnd_PresentValue;
              vals.finalEstValueManagedFund = this.engineResults.ManagedFund[this.incomePlanStart - 2].FundsAvailableAtEnd_PresentValue;
              vals.finalEstValueTermDeposit = this.engineResults.SavingsAccount[this.incomePlanStart - 2].BalanceAtEnd_PresentValue;
              
              vals.finalEstValueAtYearNumber = this.engineResults.InvestmentBond[this.incomePlanStart - 1].ProjectionYear;

              vals.finalTaxSavingsValue = 0;
              for (let i = 0; i < this.incomePlanStart; i++) {
                vals.finalTaxSavingsValue += this.engineResults.TaxSavings[i];
              }
              vals.finalTaxSavingsAtYearNumber = this.engineResults.InvestmentBond[this.incomePlanStart - 1].ProjectionYear;
            }
          } else {
            vals.estValue = this.engineResults.InvestmentBond[2].BalanceAtEnd_PresentValue;
            vals.estValueAtYearNumber = this.engineResults.InvestmentBond[2].ProjectionYear;

            vals.taxSavingsValue = 0;
            for (let i = 0; i < 5; i++) {
              vals.taxSavingsValue += this.engineResults.TaxSavings[i];
            }
            vals.taxSavingsAtYearNumber = this.engineResults.InvestmentBond[2].ProjectionYear;
          }
          
          vals.capitalGainsTaxPayableAtYearManagedFund = this.engineResults.ManagedFund[Math.min(vals.investmentTermYear, vals.finalEstValueAtYearNumber)].CapitalGainsTaxPayableOnTermination_PresentValue;

        } else {  
          if(this.engineResults.InvestmentBond_YearAttainSavingsGoal > 0) {
            vals.funeralBondEvantuallyReachedSavingsGoal = true;
            
            vals.funeralSavingsGoalOnTrack = this.engineResults.InvestmentBond_YearAttainSavingsGoal > 0 && this.engineResults.InvestmentBond_YearAttainSavingsGoal <= this.targetSavingDuration;
            vals.funeralYearAttainSavingsGoalBond = this.engineResults.InvestmentBond_YearAttainSavingsGoal;
            vals.funeralYearAttainSavingsGoalManagedFund = this.engineResults.ManagedFund_YearAttainSavingsGoal;
            vals.funeralYearAttainSavingsGoalTermDeposit = this.engineResults.BankSavingsAccount_YearAttainSavingsGoal;

            vals.funeralBalanceAtEndPresentValueYearAttainedBond = this.engineResults.InvestmentBond[vals.funeralYearAttainSavingsGoalBond - 1].BalanceAtEnd_PresentValue; 
            vals.funeralBalanceAtEndPresentValueYearAttainedManagedFund = this.engineResults.ManagedFund[vals.funeralYearAttainSavingsGoalBond - 1].FundsAvailableAtEnd_PresentValue; 
            vals.funeralBalanceAtEndPresentValueYearAttainedTermDeposit = this.engineResults.SavingsAccount[vals.funeralYearAttainSavingsGoalBond - 1].BalanceAtEnd_PresentValue; 
            vals.funeralCapitalGainsTaxPayableAtYearManagedFund = this.engineResults.ManagedFund[vals.funeralYearAttainSavingsGoalBond - 1].CapitalGainsTaxPayableOnTermination_PresentValue;

            vals.funeralBalanceAtEndPresentValueTargetYearBond = this.engineResults.InvestmentBond[this.targetSavingDuration].BalanceAtEnd_PresentValue;
            vals.funeralBalanceAtEndPresentValueTargetYearManagedFund = this.engineResults.ManagedFund[this.targetSavingDuration].FundsAvailableAtEnd_PresentValue;
            vals.funeralBalanceAtEndPresentValueTargetYearTermDeposit = this.engineResults.SavingsAccount[this.targetSavingDuration].BalanceAtEnd_PresentValue;
          } else {
            vals.funeralBondEvantuallyReachedSavingsGoal = false;
          }  
        }

        if (!(this.enabledIncomePlan && this.incomePlanFieldsValid)) {
          vals.investmentEarnings = this.engineResults.InvestmentEarningsYoY_PresentValue[this.engineResults.InvestmentBond.length - 1];
          vals.finalEstValue = this.engineResults.InvestmentBond[this.engineResults.InvestmentBond.length - 1].BalanceAtEnd_PresentValue;
          vals.finalEstValueManagedFund = this.engineResults.ManagedFund[this.engineResults.ManagedFund.length - 1].FundsAvailableAtEnd_PresentValue;
          vals.finalEstValueTermDeposit = this.engineResults.SavingsAccount[this.engineResults.SavingsAccount.length - 1].BalanceAtEnd_PresentValue;

          vals.finalEstValueAtYearNumber = this.engineResults.InvestmentBond[this.engineResults.InvestmentBond.length - 1].ProjectionYear;

          //vals.finalTaxSavingsValue = this.engineResults.TaxSavings[this.engineResults.InvestmentBond.length - 1];
          vals.finalTaxSavingsValue = this.engineResults.TaxSavings_TotalPresentValue;
          vals.finalTaxSavingsAtYearNumber = this.engineResults.InvestmentBond[this.engineResults.InvestmentBond.length - 1].ProjectionYear;
        }
      }

      return vals;
    },

    balanceUntil() {
      const vals = {
        bondYear: null,
        bondYearNumber: null,
        managedFundYear: null,
        termDepositYear: null
      };

      if (this.resultsFieldsValid && this.engineResults && this.engineResults.InvestmentBond) {

        vals.bondYear = new Date().getFullYear() + this.engineResults.InvestmentBond[this.engineResults.InvestmentBond.length - 1].ProjectionYear;
        vals.bondYearNumber = this.engineResults.InvestmentBond[this.engineResults.InvestmentBond.length - 1].ProjectionYear;

        for (let i = 0; i < this.engineResults.InvestmentBond.length; i++) {
          if (this.engineResults.InvestmentBond[i].BalanceAtEnd_PresentValue <= 0) {
            vals.bondYear = new Date().getFullYear() + this.engineResults.InvestmentBond[i].ProjectionYear;
            vals.bondYearNumber = this.engineResults.InvestmentBond[i].ProjectionYear;
            break;
          }
        }

        vals.managedFundYear = new Date().getFullYear() + this.engineResults.ManagedFund[this.engineResults.ManagedFund.length - 1].ProjectionYear;

        for (let i = 0; i < this.engineResults.ManagedFund.length; i++) {
          if (this.engineResults.ManagedFund[i].FundsAvailableAtEnd_PresentValue <= 0) {
            vals.managedFundYear = new Date().getFullYear() + this.engineResults.ManagedFund[i].ProjectionYear;
            break;
          }
        }

        vals.termDepositYear = new Date().getFullYear() + this.engineResults.SavingsAccount[this.engineResults.SavingsAccount.length - 1].ProjectionYear;

        for (let i = 0; i < this.engineResults.SavingsAccount.length; i++) {
          if (this.engineResults.SavingsAccount[i].BalanceAtEnd_PresentValue <= 0) {
            vals.termDepositYear = new Date().getFullYear() + this.engineResults.SavingsAccount[i].ProjectionYear;
            break;
          }
        }

      }
      return vals;
    },

    investmentTermYears() {
      const yearArr = [];
      for (var i = 10; i <= this.investmentTerm; i++) {
        yearArr.push(i + 1);
      }
      return yearArr;
    },

    lumpSumWithdrawalYears() {
      const yearArr = [];
      for (var i = 10; i <= this.investmentTerm; i++) {
        yearArr.push(i + 1);
      }
      return yearArr;
    },

    lumpSumFieldsReqd() {
      return ((typeof this.incomePlanLumpSumWithdrawal === 'number' && this.incomePlanLumpSumWithdrawal !== 0) || typeof this.incomePlanLumpSumWithdrawalYear === 'number');
    }

    // superProjection() { // Graph data source
    //   let subjectAgeIndex = null;
    //   let partnerAgeIndex = null;

    //   let finalObj = {
    //     deflatedSubjectAssetsAtRetirement: 0,
    //     incomeInRetirement: null,
    //     superannuationBalance: null,

    //     deflatedPartnerAssetsAtRetirement: 0,
    //     partnerIncomeInRetirement: null,
    //     partnerSuperannuationBalance: null,

    //     subjectRetirementAge: null,
    //     partnerRetirementAge: null,

    //     subjectLifeExpectancy: null,
    //     partnerLifeExpectancy: null,
    //   }

    //   if (this.solverEngineResult) {
    //     subjectAgeIndex = this.solverEngineResult.engineResults.subjectOutput.age.indexOf(this.targetSolverConfig.RetirementAge);
    //     finalObj.deflatedSubjectAssetsAtRetirement = this.solverEngineResult.engineResults.subjectOutput.deflatedAssetsInYear[subjectAgeIndex];

    //     finalObj.subjectRetirementAge = this.solverEngineResult.engineResults.subjectRetirementAge;
    //     finalObj.subjectLifeExpectancy = this.solverEngineResult.engineResults.subjectOutput.lifeExpectancy;

    //     let subjectStart = 0;
    //     let partnerStart = 0;

    //     let superannuationBalance = [];
    //     let partnerSuperannuationBalance = [];
    //     let incomeInRetirement = [];
    //     let partnerIncomeInRetirement = [];

    //     if (this.relationshipStatus == 'couple') {
    //       subjectStart = this.targetSolverConfig.RetirementAge;
    //       partnerStart = this.targetSolverConfig.RetirementAge_2;

    //       if (partnerStart < subjectStart) {
    //         for (let i = partnerStart; i < subjectStart; i++) {
    //           incomeInRetirement.push({ 
    //             age: i, 
    //             actualDrawings: 0, 
    //             agePension: 0
    //           });

    //           superannuationBalance.push({ 
    //             age: i, 
    //             balance: 0
    //           });
    //         }
    //       } else if (subjectStart < partnerStart) {
    //         for (let i = subjectStart; i < partnerStart; i++) {
    //           partnerIncomeInRetirement.push({ 
    //             age: i, 
    //             actualDrawings: 0, 
    //             agePension: 0
    //           });

    //           partnerSuperannuationBalance.push({ 
    //             age: i, 
    //             balance: 0
    //           });
    //         }
    //       }
    //     }

    //     for (let i = (finalObj.subjectRetirementAge - this.targetSolverConfig.AgeNow); i < this.solverEngineResult.engineResults.subjectOutput.age.length; i++) {
    //       if (this.solverEngineResult.engineResults.subjectOutput.age[i] <= 100) {
    //         superannuationBalance.push({ 
    //           age: this.solverEngineResult.engineResults.subjectOutput.age[i], 
    //           balance: this.solverEngineResult.engineResults.subjectOutput.deflatedAssetsInYear[i]
    //         });
    //       }
    //     }
    //     finalObj.superannuationBalance = superannuationBalance;

    //     for (let i = (finalObj.subjectRetirementAge - this.targetSolverConfig.AgeNow); i < this.solverEngineResult.engineResults.subjectOutput.age.length; i++) {
    //       if (this.solverEngineResult.engineResults.subjectOutput.age[i] >= this.solverEngineResult.engineResults.subjectRetirementAge && 
    //         this.solverEngineResult.engineResults.subjectOutput.age[i] < 101
    //       ) {
    //         incomeInRetirement.push({ 
    //           age: this.solverEngineResult.engineResults.subjectOutput.age[i], 
    //           actualDrawings: this.solverEngineResult.engineResults.subjectOutput.deflatedActualDrawingsInYear[i], 
    //           agePension: this.solverEngineResult.engineResults.subjectOutput.deflatedAgePension[i]
    //         });
    //       }
    //     }
    //     finalObj.incomeInRetirement = incomeInRetirement;

    //     if (this.relationshipStatus == 'couple') {
    //       finalObj.partnerRetirementAge = this.solverEngineResult.engineResults.partnerRetirementAge;
    //       finalObj.partnerLifeExpectancy = this.solverEngineResult.engineResults.partnerOutput.lifeExpectancy;
    //       partnerAgeIndex = this.solverEngineResult.engineResults.partnerOutput.age.indexOf(this.targetSolverConfig.RetirementAge_2);
    //       finalObj.deflatedPartnerAssetsAtRetirement = this.solverEngineResult.engineResults.partnerOutput.deflatedAssetsInYear[partnerAgeIndex];

    //       for (let i = (finalObj.partnerRetirementAge - this.targetSolverConfig.AgeNow_2); i < this.solverEngineResult.engineResults.partnerOutput.age.length; i++) {
    //         if (this.solverEngineResult.engineResults.partnerOutput.age[i] <= 100) {
    //           partnerSuperannuationBalance.push({ 
    //             age: this.solverEngineResult.engineResults.partnerOutput.age[i], 
    //             balance: this.solverEngineResult.engineResults.partnerOutput.deflatedAssetsInYear[i]
    //           });
    //         }
    //       }
    //       finalObj.partnerSuperannuationBalance = partnerSuperannuationBalance;

    //       for (let i = (finalObj.partnerRetirementAge - this.targetSolverConfig.AgeNow_2); i < this.solverEngineResult.engineResults.partnerOutput.age.length; i++) {
    //         if (this.solverEngineResult.engineResults.partnerOutput.age[i] >= this.solverEngineResult.engineResults.partnerRetirementAge && 
    //           this.solverEngineResult.engineResults.partnerOutput.age[i] < 101
    //         ) {
    //           partnerIncomeInRetirement.push({ 
    //             age: this.solverEngineResult.engineResults.partnerOutput.age[i], 
    //             actualDrawings: this.solverEngineResult.engineResults.partnerOutput.deflatedActualDrawingsInYear[i], 
    //             agePension: this.solverEngineResult.engineResults.partnerOutput.deflatedAgePension[i]
    //           });
    //         }
    //       }
    //       finalObj.partnerIncomeInRetirement = partnerIncomeInRetirement;
    //     }
    //   }

    //   return finalObj;
    // },
  },

  watch: {
    formFieldWatcher: {
      handler() {
        this.$refs.resultsPanel.$el.classList.remove("was-validated");
        if (parseInt(this.activeTab) === 4) {
          if (this.resultsFieldsValid) {
            this.runEngine();
          } else {
            this.validateForm();
          }
        }
      },
      deep: true
    },

    activeTab(newVal, oldVal) {
      if (parseInt(oldVal) !== 4 && parseInt(newVal) === 4) {
        this.runEngine();
      }
    },

    incomePlanFieldsValid(newVal) {
      if (!newVal || (newVal && this.incomePlanFieldsValid)) {
        this.runEngine();
      }
    },
  },

  methods: {
    validateForm() {
      return this.checkForm(this.$refs.resultsPanel.$el);
    },

    checkForm(form) {
      form.classList.add("was-validated");
      return form.checkValidity();
    },
    
    safeFieldValue(fieldToCheck) {
      return ((typeof fieldToCheck !== 'undefined') && !isNaN(parseFloat(fieldToCheck)) ? fieldToCheck : 0)
    },

    printResults() {
      window.print();
    },

    keyUpToggleEnableIncomePlan(event) {
      if (event.keyCode === 13 || event.keyCode === 32) {
        this.toggleEnableIncomePlan();
      }
    },

    toggleEnableIncomePlan() {
      this.$store.commit("setEnableIncomePlan", !this.enabledIncomePlan);
    },

    resetModeller() {
      this.$store.commit("resetModeller");
    },

    // funeralBondProjection(year) {
    //   let balanceAtYear = []; // balanceAtEndPresentValueYear

    //   if (this.resultsFieldsValid && this.engineResults && this.engineResults.InvestmentBond) {
    //     balanceAtYear.push(Math.round(this.engineResults.InvestmentBond[year].BalanceAtEnd_PresentValue));
    //     balanceAtYear.push(Math.round(this.engineResults.ManagedFund[year].BalanceAtEnd_PresentValue));
    //     balanceAtYear.push(Math.round(this.engineResults.SavingsAccount[year].BalanceAtEnd_PresentValue));
    //   }

    //   return balanceAtYear;
    // },

    whichYearFuneralFundAttained(year) {
      let whichYear;

      if (this.resultsFieldsValid && this.engineResults && this.engineResults.InvestmentBond) {
        const aYearFromNow = new Date();
        aYearFromNow.setFullYear(aYearFromNow.getFullYear() + year);
        whichYear = aYearFromNow.getFullYear();
      }

      return whichYear + 1;
    },

    //color graident generator  
    hexToRgba(hex, alpha) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? 'rgba(' + parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16) + ',' + (alpha || 0) + ')' : null;
    },

    loadBalanceGraphData() {
      let series1 = []; // investmentBondBalanceAtEachYearEnd
      let series2 = []; // managedFundBalanceAtEachYearEnd
      let series3 = []; // savingsAccountBalanceAtEachYearEnd

      let yearLabel = [];

      if (this.resultsFieldsValid && this.engineResults && this.engineResults.InvestmentBond) {
        series1.push(Math.round(this.startingDeposit));
        series2.push(Math.round(this.startingDeposit));
        series3.push(Math.round(this.startingDeposit));

        for (let i = 1; i < Object.keys(this.engineResults.InvestmentBond).length + 1; i++) {
          series1.push(Math.round(this.engineResults.InvestmentBond[i - 1].BalanceAtEnd_PresentValue));
          series2.push(Math.round(this.engineResults.ManagedFund[i - 1].BalanceAtEnd_PresentValue));
          series3.push(Math.round(this.engineResults.SavingsAccount[i - 1].BalanceAtEnd_PresentValue));
          yearLabel.push(i);
        }
      }      

      // let graphData = Array.from({length: 101 - retirementAge}, () => retirementAge++); // Fills array with ages starting from retirement

      this.balanceChartOptions.xAxis.categories = yearLabel;
      this.balanceChartOptions.xAxis.categories.push('Year end'); // to avoid confusion between year start and year end


      if (this.incomePlanStart && this.enabledIncomePlan) {
        this.balanceChartOptions.xAxis.plotLines[0].value = this.incomePlanStart - 1; // change income plan plotline
      } 

      if (this.incomePlanLumpSumWithdrawalYear && this.enabledIncomePlan) {
        this.balanceChartOptions.xAxis.plotLines[1].value = this.incomePlanLumpSumWithdrawalYear - 1; // change income plan plotline
      }

      if (!this.enabledIncomePlan || this.typeOfBond != 1) {
        this.balanceChartOptions.xAxis.plotLines[0].value = 500; // change income plan plotline (500 is just so it dissapear)
        this.balanceChartOptions.xAxis.plotLines[1].value = 500; 
      } 

      if (this.typeOfBond != 1) {
        this.balanceChartOptions.yAxis.plotLines[0].value = this.requiredFuneralFund;
        this.balanceChartOptions.yAxis.plotLines[0].width = 2;
        this.balanceChartOptions.yAxis.plotLines[0].label.style.color = 'black';
      } else {
        this.balanceChartOptions.yAxis.plotLines[0].width = 0;
        this.balanceChartOptions.yAxis.plotLines[0].label.style.color = 'transparent';
      }


      // Plot series LAST
      this.balanceChartOptions.series[0].data = series1;
      this.balanceChartOptions.series[1].data = series2;
      this.balanceChartOptions.series[2].data = series3;

      // if (this.relationshipStatus == 'couple') {
      //   this.balanceChartOptions.series[1] = {
      //     name: "Partner's balance",
      //     data: series2,
      //   }
      // } else {
      //   if (this.balanceChartOptions.series.length > 1) {
      //     this.balanceChartOptions.series.splice(1, 1);
      //   }
      // }
    },

    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ffApp");

      this.$triggerIframeAnalytics({
        event: "calculator",
        calculator_name: "Investment Forecaster",
        calculator_section: this.analyticsPageNames[this.lastActiveTab],
        calculator_step: tabNum < this.lastActiveTab ? "Back" : "Continue",
      });

      if (this.debugMode)
        console.log(
          "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
          this.analyticsPageNames[this.lastActiveTab] + 
          ", calculator_step: " + 
          (tabNum < this.lastActiveTab ? "Back" : "Continue")
        );

      // Pretend this is an onload of the next page
      setTimeout(() => {
        this.$triggerIframeAnalytics({
          event: "calculator",
          calculator_name: "Investment Forecaster",
          calculator_section: this.analyticsPageNames[this.activeTab],
          calculator_step: "Start",
        });

        if (this.debugMode)
          console.log(
            "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
            this.analyticsPageNames[this.activeTab] + 
            ", calculator_step: Start"
          );
      }, 100);
    },

    runEngine() {
      if (!this.resultsFieldsValid || (this.enabledIncomePlan && !this.incomePlanFieldsValid)) {
        return;
      }

      this.$store.commit("setLoading", true);

      setTimeout(() => {
        this.runProjectionEngine();

        const scrollTo = scroller();
        scrollTo("#resultsPage", 300, {offset: -60});
        this.loadBalanceGraphData();
      }, 20);
    },

    runProjectionEngine() {
      const inputObj = GetDefaultInputs();

      inputObj.WageInflation = this.$div100(this.wageInflation);
      inputObj.PriceInflation = this.$div100(this.priceInflation);
      inputObj.AssetFee = this.$div100(this.assetFee);
      inputObj.BankSavingsRate = 0.02; // Where does this come from and what's it meant to be?
      inputObj.CapitalGain = 0.03; // Where does this come from and what's it meant to be?s

      // Inputs
      inputObj.Salary = this.typeOfBond === 1 ? this.grossIncome : 50000; //  The median Australian employee earned $65,000 in 2022, according to the Australian Bureau of Statistics.
      inputObj.StartingDeposit = this.startingDeposit;
      inputObj.InvestmentTerm = this.typeOfBond === 1 ? this.investmentTerm : this.targetSavingDuration + 10; // add 10 years on top of targetSavingDuration for funeral bond

      inputObj.ExtraContributions_Annual = this.makeRegularContributions ? (this.extraContributions / this.extraContributionFrequencyFraction) : 0;
      inputObj.ExtraContributions_RateOfIncrease = this.extraContributionsRateOfIncrease;
      inputObj.ExtraContributions_YearCeases = 10; // hardcoded at 10 as per client request
      // inputObj.ExtraContributions_YearCeases = this.typeOfBond === 1 ? this.investmentTerm + 1 : this.targetSavingDuration + 10; // No input for this. so never ceases?

      if (this.enabledIncomePlan && this.typeOfBond === 1) {
        inputObj.IncomePlan_AnnualIncome = (this.incomePlanContributions / this.incomePlanContributionFrequencyFraction);
        inputObj.IncomePlan_LumpSumWithdrawal = this.incomePlanLumpSumWithdrawal;
        inputObj.IncomePlan_LumpSumWithdrawal_YearOfWithdrawal = !isNaN(this.incomePlanLumpSumWithdrawalYear) && typeof this.incomePlanLumpSumWithdrawalYear !== 'string' ? this.incomePlanLumpSumWithdrawalYear : 0;
        inputObj.IncomePlan_StartYear = this.incomePlanStart;

        inputObj.IncomePlan_AnnualIncomeIndexationRate = this.$div100(this.wageInflation); // Assuming same as wage inflation
        inputObj.IncomePlan_LumpSumWithdrawal_IndexationRate = this.$div100(this.wageInflation); // Assuming same as wage inflation
      } else {
        inputObj.IncomePlan_AnnualIncome = 0;
        inputObj.IncomePlan_LumpSumWithdrawal = 0;
        inputObj.IncomePlan_LumpSumWithdrawal_YearOfWithdrawal = 0;
        inputObj.IncomePlan_StartYear = 0;
      }

      inputObj.InvestmentReturn = this.$div100(this.selectedInvestmentReturnRate);
      inputObj.SavingsGoal = this.requiredFuneralFund; // Phase 2? Used as funeral saving target?

      this.engineResults = RunProjection(inputObj, true);

      this.$triggerIframeAnalytics({
        event: "calculator",
        calculator_name: "Investment Forecaster",
        calculator_section: this.analyticsPageNames[this.lastActiveTab],
        calculator_step: "Engine Calculation",
        investor_type: this.typeOfInvestor === 1 ? "Direct" : this.typeOfInvestor === 2 ? "Funeral" : "Adviser",
        // engine_results: { 
        //   xxx: this.engineResults.xxx, 
        //   yyy: this.engineResults.yyy, 
        // } // Need to specify EXACTLY what data to log
      });

      if (this.debugMode)
        console.log(
          "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
          this.analyticsPageNames[this.lastActiveTab] + 
          ", calculator_step: Engine Calculation, " + 
          "investor_type: " + (this.typeOfInvestor === 1 ? "Direct" : this.typeOfInvestor === 2 ? "Funeral" : "Adviser") + ", engine_results: ",
          this.engineResults
        );

      setTimeout(() => {
        this.$store.commit("setLoading", false);
      }, 100);
    },
  },

  mounted() {},
};

</script>

<template>
  <MDBContainer fluid class="result-page" id="resultsPage">
    <MDBRow class="p-0 needs-validation" tag="form" novalidate ref="resultsPanel" @submit.prevent>
      <MDBCol cmd="11" class="main-content-wrapper" tabindex="0">

        <MDBRow class="mx-auto">
          <MDBCol col="12" lg="9" class="mx-auto px-0 pe-lg-3 pb-3">
            <MDBRow>
              <MDBCol>
                <MDBTabs v-model="activeTabId">
                  <MDBTabNav tabsClasses="results-nav mx-4 d-print-none">
                    <MDBTabItem tabId="result1-1" href="result1-1">
                      Summary
                    </MDBTabItem>

                    <MDBTabItem tabId="result1-2" href="result1-2">
                      Breakdown
                    </MDBTabItem>
                  </MDBTabNav>

                  <MDBTabContent class="results-tab">
                    <MDBTabPane tabId="result1-1" class="summary-pane">

                      <MDBRow class="mx-0" v-if="typeOfBond === 2 && coinGraphTotals.funeralSavingsGoalOnTrack" >
                        <MDBCol col="11" md="6" class="px-0 mx-auto my-3">
                          <div class="panel main-panel">
                            <div class="card green-card px-3 pt-3">
                              <MDBRow class="p-0">
                                <MDBCol class="p-2 px-lg-3 text-center">
                                  <p>
                                    Great news! You are ahead of your target!
                                    Your saving goal was ${{ $formatCurrency(this.requiredFuneralFund) }}.
                                  </p>
                                  <p>
                                    You are estimated to hit<br />your savings target in
                                    <strong class="d-inline-block">
                                      Year {{coinGraphTotals.funeralYearAttainSavingsGoalBond + 1}}
                                  </strong>.
                                  </p>
                                </MDBCol>
                              </MDBRow>
                            </div>
                          </div>
                        </MDBCol>
                      </MDBRow>

                      <MDBRow class="mx-0" v-if="typeOfBond === 2 && !coinGraphTotals.funeralSavingsGoalOnTrack">
                        <MDBCol col="11" md="6" class="px-0 mx-auto my-3">
                          <div class="panel main-panel">
                            <div class="card red-card px-3 pt-3">
                              <MDBRow class="p-0">
                                <MDBCol class="p-2 px-lg-3 text-center">
                                  <p>
                                    Unfortunately you are not quite there yet!
                                    Your saving goal was ${{ $formatCurrency(this.requiredFuneralFund) }}.
                                  </p>
                                  <p v-if="coinGraphTotals.funeralBondEvantuallyReachedSavingsGoal">
                                    You are estimated to hit<br/>your savings target in
                                    <strong class="d-inline-block">
                                      Year {{coinGraphTotals.funeralYearAttainSavingsGoalBond + 1}}
                                    </strong>.
                                  </p>
                                  <p v-else>
                                    You may want to increase your regular contribution to see when will you reach your saving goal.
                                  </p>
                                  <p>
                                    Use the options below to 
                                    <a>fine tune your projection</a>  
                                    and see how you can achieve your target savings goals earlier.
                                  </p>

                                  <MDBBtn
                                    class="btn-primary back my-3 d-print-none align-self-center"
                                    @click="clickToTab(5)"
                                    aria-label="Talk to us button"
                                  >
                                    Talk to us
                                  </MDBBtn>
                                </MDBCol>
                              </MDBRow>
                            </div>
                          </div>
                        </MDBCol>
                      </MDBRow>

                      <MDBRow class="mx-0" v-if=" typeOfBond === 1 || coinGraphTotals.funeralBondEvantuallyReachedSavingsGoal">
                        <MDBCol class="px-3 py-4">  
                          <h3 class="d-print-block d-none">Summary</h3>
                          <div class="pb-3 mx-5 px-5 text-center summary">

                            In <span class="resultsYear">year {{ (typeOfBond != 1) ? coinGraphTotals.funeralYearAttainSavingsGoalBond + 1 : (projectionTime === '10YearProjection') ? '10' : Math.min(coinGraphTotals.investmentTermYear, coinGraphTotals.finalEstValueAtYearNumber) }} </span>, your balance will be:<br />
                            
                            <span class="resultsBalanceAmount">${{ $formatCurrency(  (typeOfBond != 1) ? coinGraphTotals.funeralBalanceAtEndPresentValueYearAttainedBond : (projectionTime === '10YearProjection') ? coinGraphTotals.estValue : coinGraphTotals.finalEstValue  ) }}
                            </span>
                            
                            <ToolTip text="Your results shows a negative tax benefit as your marginal tax rate is sitting below bond's flat tax rate of 30%" v-if="((typeOfBond != 1) ? coinGraphTotals.funeralCapitalGainsTaxPayableAtYearManagedFund : (projectionTime === '10YearProjection') ? coinGraphTotals.capitalGainsTaxPayableAtYear10ManagedFund : coinGraphTotals.capitalGainsTaxPayableAtEndManagedFund) <= 0">
                              <span class="icon-info"></span>
                            </ToolTip>
                            
                            <br />
                            
                            <p v-if="((typeOfBond != 1) ? coinGraphTotals.funeralCapitalGainsTaxPayableAtYearManagedFund : (projectionTime === '10YearProjection') ? coinGraphTotals.capitalGainsTaxPayableAtYear10ManagedFund : coinGraphTotals.capitalGainsTaxPayableAtEndManagedFund) > 0">
                              You'll save approx. 
                              <span v-if="coinGraphTotals.taxSavingsValue > 0" class="resultsSavingsAmount">
                                ${{ $formatCurrency(  (typeOfBond != 1) ? coinGraphTotals.taxSavingsValue : (projectionTime === '10YearProjection') ? coinGraphTotals.taxSavingsValue : coinGraphTotals.finalTaxSavingsValue) }}
                              </span> 
                              <span v-if="coinGraphTotals.taxSavingsValue > 0"> of Income Tax, and </span>
                              <span class="resultsSavingsAmount">
                                ${{ $formatCurrency( (typeOfBond != 1) ? coinGraphTotals.funeralCapitalGainsTaxPayableAtYearManagedFund : (projectionTime === '10YearProjection') ? coinGraphTotals.capitalGainsTaxPayableAtYear10ManagedFund : coinGraphTotals.capitalGainsTaxPayableAtEndManagedFund ) }}
                              </span> 
                              of Capital Gains Tax compared to a managed fund with a similar return. Learn more about other <a href="https://forestersfinancial.com.au/news/the-many-benefits-of-an-often-overlooked-investment-structure/" target="_blank">benefits of bond.</a>
                            </p>
                            <p v-else>
                              While the result is indicating no tax advantages to bond, other advantages of a bond such as legal protection or use for intergenerational wealth transfer will still apply. <a href="https://forestersfinancial.com.au/news/the-many-benefits-of-an-often-overlooked-investment-structure/" target="_blank">Learn more.</a>
                            </p>
                           
                            <!-- Your estimated value at <strong>Year {{ typeOfBond === 1 ? coinGraphTotals.finalTaxSavingsAtYearNumber : targetSavingDuration }}</strong>
                            <span v-if="enabledIncomePlan && incomePlanFieldsValid">
                              <br />
                              (prior to withdrawals)
                            </span> -->
                            <p>
                              <MDBBtn
                                class="btn-primary back my-3 d-print-none"
                                @click="clickToTab(5)"
                                aria-label="Talk to us button"
                              >
                                Talk to us
                              </MDBBtn>
                            </p>
                          </div>

                          

                          <CoinGraph
                            :stackMax="projectionTime === '10YearProjection' ? 10 : 12 "
                            :investmentEarnings="0" 
                            :bondContributions="(typeOfBond != 1) ? coinGraphTotals.funeralBalanceAtEndPresentValueYearAttainedBond : (projectionTime === '10YearProjection') ? coinGraphTotals.estValue : coinGraphTotals.finalEstValue" 
                            :managedFund="(typeOfBond != 1)  ? coinGraphTotals.funeralBalanceAtEndPresentValueYearAttainedManagedFund : (projectionTime === '10YearProjection') ? coinGraphTotals.estValueManagedFund : coinGraphTotals.finalEstValueManagedFund" 
                            :termDeposit="(typeOfBond != 1)  ? coinGraphTotals.funeralBalanceAtEndPresentValueYearAttainedTermDeposit : (projectionTime === '10YearProjection')? coinGraphTotals.estValueTermDeposit : coinGraphTotals.finalEstValueTermDeposit" 
                            :bondLabel="'Your investment bond'"
                            :capitalGainManagedFund = "(typeOfBond != 1) ? coinGraphTotals.funeralCapitalGainsTaxPayableAtYearManagedFund : (projectionTime === '10YearProjection') ? coinGraphTotals.capitalGainsTaxPayableAtYear10ManagedFund : coinGraphTotals.capitalGainsTaxPayableAtEndManagedFund" 
                          />
                        </MDBCol>
                      </MDBRow>

                      <MDBRow class="mx-0" v-if="typeOfBond === 2 && coinGraphTotals.funeralBondEvantuallyReachedSavingsGoal">
                        <MDBCol col="11" md="6" class="p-3 mx-auto text-center page-break-before">
                          <p>
                            When will I reach my target balance?
                          </p>
                        </MDBCol>
                      </MDBRow>
<!-- data needs wiring -->

                      <MDBRow class="mx-0" v-if="typeOfBond === 2 && coinGraphTotals.funeralBondEvantuallyReachedSavingsGoal">
                        <MDBCol col="11" md="3" class="px-0 mx-auto mb-3">
                          <div class="panel main-panel">
                            <div class="card main-card px-3 results">
                              <MDBRow class="p-0">
                                <MDBCol class="p-2 text-center resultsBox">
                                  <span class="coinTotal centered">{{ whichYearFuneralFundAttained(coinGraphTotals.funeralYearAttainSavingsGoalBond) }}</span>
                                  <small>(Year {{coinGraphTotals.funeralYearAttainSavingsGoalBond + 1}})</small>
                                  <p>INVESTMENT BOND</p>
                                </MDBCol>                                                   
                              </MDBRow>
                            </div>
                          </div>
                        </MDBCol>
                        <MDBCol col="11" md="7" class="px-0 mx-auto mb-3">
                          <div class="panel main-panel">
                            <div class="card main-card px-3 results">
                              <MDBRow class="p-0">
                                <MDBCol class="p-2 text-center resultsBox" v-if="coinGraphTotals.funeralYearAttainSavingsGoalManagedFund > 0">
                                  <span class="coinTotal coinTotalMid centered">{{ whichYearFuneralFundAttained(coinGraphTotals.funeralYearAttainSavingsGoalManagedFund) }}</span>
                                  <small>(Year {{coinGraphTotals.funeralYearAttainSavingsGoalManagedFund + 1}})</small>
                                  <p>MANAGED FUND</p>
                                </MDBCol>
                                <MDBCol class="p-2 text-center resultsBox" v-if="coinGraphTotals.funeralYearAttainSavingsGoalTermDeposit > 0">                                  
                                  <span class="coinTotal coinTotalMid centered">{{ whichYearFuneralFundAttained(coinGraphTotals.funeralYearAttainSavingsGoalTermDeposit) }}</span>
                                  <small>(Year {{coinGraphTotals.funeralYearAttainSavingsGoalTermDeposit + 1}})</small>
                                  <p>TERM DEPOSIT</p>
                                </MDBCol>                    
                              </MDBRow>
                            </div>
                          </div>
                        </MDBCol>
                      </MDBRow>

                      <!-- need to change data -->
                      <MDBRow class="mx-auto p-3 pb-0" v-if="typeOfBond === 2 && coinGraphTotals.funeralBondEvantuallyReachedSavingsGoal">
                        <MDBCol col="12" class="p-0 mt-4">
                          <div class="panel main-panel">
                            <div class="card main-card" id="editRetirement">
                              <MDBAccordion v-model="accordion.two">
                                <MDBAccordionItem
                                  headerTitle="Funeral balance comparison"
                                  collapseId="collapseTwo"
                                  class="funeralBalanceComparison"
                                >
                                <MDBTable>
                                  <thead>
                                    <tr>
                                      <th scope="col">Product</th>
                                      <th scope="col">CGT* to pay</th>
                                      <th scope="col">Available balance (Year {{ whichYearFuneralFundAttained(coinGraphTotals.funeralYearAttainSavingsGoalBond + 1) }})</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="funeralBond" >
                                      <td><strong>Funeral bond</strong></td>
                                      <td>$0</td>
                                      <td class="green">${{ $formatCurrency(this.coinGraphTotals.funeralBalanceAtEndPresentValueYearAttainedBond) }}</td>
                                    </tr>
                                    <tr>
                                      <td><strong>Managed fund</strong></td>
                                      <td class="red">${{ $formatCurrency(this.coinGraphTotals.funeralCapitalGainsTaxPayableAtYearManagedFund) }}</td>
                                      <td>${{ $formatCurrency(this.coinGraphTotals.funeralBalanceAtEndPresentValueYearAttainedManagedFund) }}</td>
                                    </tr>
                                    <tr>
                                      <td><strong>Term deposit</strong></td>
                                      <td>$0</td>
                                      <td>${{ $formatCurrency(this.coinGraphTotals.funeralBalanceAtEndPresentValueYearAttainedTermDeposit) }}</td>
                                    </tr>
                                  </tbody>
                                </MDBTable>                                    
                                </MDBAccordionItem>
                              </MDBAccordion>
                            </div>
                          </div>
                        </MDBCol>
                      </MDBRow>

                      <MDBRow class="mx-auto btn-wrapper results d-print-none" v-if="typeOfBond === 1">
                        <MDBBtn 
                          class="col-6" 
                          v-model="projectionTime" 
                          @click="projectionTime = '10YearProjection'" 
                          :class="projectionTime == '10YearProjection' ? 'active' : '' "
                        >
                          Year 10
                        </MDBBtn>
                        <MDBBtn 
                          class="col-6" 
                          v-model="projectionTime" 
                          @click="projectionTime = 'finalYearProjection'" 
                          :class="projectionTime == 'finalYearProjection' ? 'active' : '' "
                          >
                            Year {{ Math.min(coinGraphTotals.investmentTermYear, coinGraphTotals.finalEstValueAtYearNumber) }}
                          </MDBBtn>
                      </MDBRow>                      

                    </MDBTabPane>

                    <MDBTabPane tabId="result1-2" class="results-pane page-break-before">
                      <MDBRow class="mx-0">
                        <MDBCol class="px-3 py-4">
                          <h3 class="d-print-block d-none">Breakdown</h3>
                          <div class="pt-2">
                            <highcharts ref="balanceGraph" :options="balanceChartOptions" class="balance-graph"></highcharts>
                          </div>
                        </MDBCol>
                      </MDBRow>
                    </MDBTabPane>
                  </MDBTabContent>
                </MDBTabs>

                <MDBRow class="mx-auto p-3 pb-0" v-if="this.typeOfBond === 1">
                        <MDBCol col="12" class="px-0 mt-4 pb-2">
                          <div class="panel main-panel">
                            <div class="card main-card summary-panel">
                              <div 
                                class="set-income-plan-dropdown" 
                                @keydown="keyUpToggleEnableIncomePlan" 
                                @click.stop="toggleEnableIncomePlan()"
                                tabindex="0"
                              >
                                <span class="incomePlanLabel">
                                  Set an income plan
                                </span>
              
                                <input
                                  class="enableCheckbox"
                                  type="checkbox"
                                  name="enableIncomePlan"
                                  id="enableIncomePlan"
                                  value="1"
                                  :checked="enabledIncomePlan"
                                  @click.stop="toggleEnableIncomePlan()"
                                  tabindex="-1"
                                />
                              </div>
              
                              <Transition name="slide">
                                <div v-show="enabledIncomePlan" class="p-4">
                                  <MDBRow>
                                    <MDBCol lg="6" class="pt-2 pt-lg-0 pb-lg-3">
                                      <MDBRow>
                                        <MDBCol>
                                          <div class="form-group">
                                            <label for="incomePlanStart" class="main-label pt-0" tabindex="0">
                                              What year would you like your income plan to start?
              
                                              <ToolTip text="When would you like to start drawing regular income from your bond balance">
                                                <span class="icon-info"></span>
                                              </ToolTip>
                                            </label>
                                          </div>
                                        </MDBCol>
                                      </MDBRow>
                                      
                                      <MDBRow>
                                        <MDBCol>
                                          <div class="form-floating mb-1 mb-lg-3">
                                            <select
                                              v-model="incomePlanStart"
                                              class="form-select form-control"
                                              name="incomePlanStart"
                                              id="incomePlanStart"
                                              required
                                            >
                                              <option value="">Please select</option>
                                              <option
                                                v-for="(option, index) in investmentTermYears"
                                                :key="index"
                                                :value="option"
                                              >
                                                Year {{ option }}
                                              </option>
                                            </select>
              
                                            <small class="pt-2" v-if="incomePlanStart != ''">
                                              <em>Between year 11 and {{ investmentTerm + 1 }} (inclusive)</em>
                                            </small>
              
                                            <div 
                                              class="invalid-feedback" 
                                              aria-live="assertive" 
                                              aria-description="Please select one of the options."
                                            >
                                              Please select one of the options.
                                            </div>
                                          </div>
                                        </MDBCol>
                                      </MDBRow>
                                      
                                      <MDBRow>
                                        <MDBCol>
                                          <div class="form-group">
                                            <label for="incomePlanContributions" class="main-label" tabindex="0">
                                              Income amount and frequency
                                            </label>
                                          </div>
                                        </MDBCol>
                                      </MDBRow>
              
                                      <MDBRow>
                                        <MDBCol lg="7">
                                          <NumInput
                                            v-model.number.lazy="incomePlanContributions"
                                            divClass=""
                                            cssClass="input"
                                            :options="{
                                              precision: { min: 0, max: 0 },
                                              valueRange: { min: 0, max: 5000000 }
                                            }"
                                            name="incomePlanContributions"
                                            label="Enter amount"
                                            placeholder="Enter amount per year"
                                            :isRequired="true"
                                            requiredDescription="Please enter a value in this field."
                                            requiredMessage="Please enter a value in this field."
                                            :class="incomePlanContributions > this.coinGraphTotals.currentBalanceAtSelectedIncomePlanStartYear ? 'red-input' : ''"
                                          />
              
                                          <!-- <small class="pt-2" v-if="incomePlanContributions > 0">
                                            <em>Between $100 and the bond investment value.</em>
                                          </small> -->

                                          <small class="pt-2 red" 
                                            v-if="incomePlanContributions > this.coinGraphTotals.currentBalanceAtSelectedIncomePlanStartYear"
                                          >
                                            Please note that the income amount should be lower than your balance at year {{ incomePlanStart }}.
                                          </small>
                                        </MDBCol>
                                        
                                        <MDBCol lg="5" class="mt-4 mt-lg-0">
                                          <div class="form-floating mb-4 mb-lg-3">
                                            <select
                                              v-model="incomePlanContributionFrequency"
                                              class="form-select form-control"
                                              name="incomePlanContributionFrequency"
                                              id="incomePlanContributionFrequency"
                                              :required="true"
                                            >
                                              <option value="">Frequency</option>
                                              <!-- <option value="fortnight">per fortnight</option> -->
                                              <option value="month">per month</option>
                                              <!-- <option value="quarter">per quarter</option> -->
                                              <option value="year">per year</option>
                                            </select>
              
                                            <!-- <label for="incomePlanContributionFrequency" v-if="incomePlanContributionFrequency != ''">
                                              Frequency
                                            </label> -->
              
                                            <div 
                                              class="invalid-feedback" 
                                              aria-live="assertive" 
                                              aria-description="Please select one of the options."
                                            >
                                              Please select one of the options.
                                            </div>
                                          </div>
                                        </MDBCol>
                                      </MDBRow>
              
                                      <MDBRow>
                                        <MDBCol lg="7" class="mt-4 mt-lg-0">
                                          <MDBRow>
                                            <MDBCol>
                                              <div class="form-group">
                                                <label for="incomePlanLumpSumWithdrawal" class="main-label" tabindex="0">
                                                  One-off lump sum withdrawal&nbsp;
                                                </label>
                                              </div>
                                            </MDBCol>
                                          </MDBRow>
                                          
                                          <MDBRow>
                                            <MDBCol>
                                              <NumInput
                                                v-model.number.lazy="incomePlanLumpSumWithdrawal"
                                                divClass=""
                                                cssClass="input"
                                                :options="{
                                                  precision: { min: 0, max: 0 },
                                                  valueRange: { min: 0, max: 5000000 }
                                                }"
                                                name="incomePlanLumpSumWithdrawal"
                                                label="Enter amount"
                                                placeholder="Enter amount per year"
                                                :isRequired="lumpSumFieldsReqd"
                                                requiredDescription="Please enter a value in this field."
                                                requiredMessage="Please enter a value in this field."
                                                :class="incomePlanLumpSumWithdrawal > this.coinGraphTotals.currentBalanceAtSelectedWithdrawalYear ? 'red-input' : ''"
                                              />
                                            </MDBCol>
                                          </MDBRow>
                                          <small class="pt-2 red" 
                                            v-if="incomePlanLumpSumWithdrawal > this.coinGraphTotals.currentBalanceAtSelectedWithdrawalYear"
                                          >
                                            Please note that the one-off lump sum withdrawal needs to be lower than your balance at year {{ incomePlanLumpSumWithdrawalYear }}.
                                          </small>
                                        </MDBCol>
              
                                        <MDBCol lg="5" class="mt-4 mt-lg-0">
                                          <MDBRow>
                                            <MDBCol>
                                              <div class="form-group">
                                                <label for="incomePlanLumpSumWithdrawalYear" class="main-label" tabindex="0">
                                                  Taken in which year?
                                                </label>
                                              </div>
                                            </MDBCol>
                                          </MDBRow>
              
                                          <MDBRow>
                                            <MDBCol>
                                              <div class="form-floating mb-4 mb-lg-3">
                                                <select
                                                  v-model="incomePlanLumpSumWithdrawalYear"
                                                  class="form-select form-control"
                                                  name="incomePlanLumpSumWithdrawalYear"
                                                  id="incomePlanLumpSumWithdrawalYear"
                                                  :required="lumpSumFieldsReqd"
                                                >
                                                  <option value="">Please select</option>
                                                  <option
                                                    v-for="(option, index) in lumpSumWithdrawalYears"
                                                    :key="index"
                                                    :value="option"
                                                  >
                                                    Year {{ option }}
                                                  </option>
                                                </select>
              
                                                <!-- <label for="incomePlanLumpSumWithdrawalYear" v-if="incomePlanLumpSumWithdrawalYear != ''">
                                                  Frequency
                                                </label> -->
              
                                                <div 
                                                  class="invalid-feedback" 
                                                  aria-live="assertive" 
                                                  aria-description="Please select one of the options."
                                                >
                                                  Please select one of the options.
                                                </div>
                                              </div>
                                            </MDBCol>
                                          </MDBRow>
                                        </MDBCol>
                                      </MDBRow>
              
                                    </MDBCol>
              
                                    <MDBCol lg="6" class="mt-4 mt-lg-0 pb-3" v-if="balanceUntil.bondYear">
                                      <div class="p-4 pt-3 incomePlanProjection">
                                        <p>
                                          Your balance will last until
                                        </p>
              
                                        <div class="card main-card px-3">
                                          <MDBRow class="p-0">
                                            <MDBCol class="p-4 px-lg-3 text-center planBox">
                                              Investment Bond
                                            </MDBCol>
                                            
                                            <MDBCol class="p-2 text-center resultsBox">
                                              <span class="coinTotal">{{ balanceUntil.bondYear }}</span>
                                              (Year {{ balanceUntil.bondYearNumber }})
                                            </MDBCol>
                                          </MDBRow>
                                        </div>
              
                                        <div class="card main-card px-3 mt-4">
                                          <MDBRow class="p-0">
                                            <MDBCol class="p-2 px-lg-3 text-center planBox">
                                              <span class="coinTotal coinTotalMid">{{ balanceUntil.managedFundYear }}</span>
                                              Managed Fund
                                            </MDBCol>
                                            
                                            <MDBCol class="p-2 px-lg-3 text-center planBox">
                                              <span class="coinTotal coinTotalMid">{{ balanceUntil.termDepositYear }}</span>
                                              Term Deposit
                                            </MDBCol>
                                          </MDBRow>
                                        </div>
                                      </div>
                                    </MDBCol>
              
                                  </MDBRow>
                                </div>
                              </Transition>
              
                            </div>
                          </div>
                        </MDBCol>  
                      </MDBRow>

                      <MDBRow class="mx-auto p-3 pt-0">
                        <MDBCol col="12" class="p-0 mt-4">
                          <div class="panel main-panel">
                            <div class="card main-card" id="editRetirement">
                              <MDBAccordion v-model="accordion.one">
                                <MDBAccordionItem
                                  headerTitle="Fine tune your projection"
                                  collapseId="collapseOne"
                                >
                                  <MDBRow class="pt-0 pt-lg-2">
              
                                    <MDBCol 
                                      lg="6" 
                                      class="pt-3 pt-lg-0" 
                                      v-if="typeOfBond === 1"
                                    >
                                      <MDBRow>
                                        <MDBCol>
                                          <div class="form-group">
                                            <label for="grossIncome" class="main-label" tabindex="0">
                                              Income (before tax and super)
              
                                              <!-- <ToolTip text="Replace this with appropriate text">
                                                <span class="icon-info"></span>
                                              </ToolTip> -->
                                            </label>
                                          </div>
                                        </MDBCol>
                                      </MDBRow>
                                      
                                      <MDBRow>
                                        <MDBCol>
                                          <NumInput
                                            v-model.number.lazy="grossIncome"
                                            divClass="rhs"
                                            cssClass="input"
                                            :options="{
                                              precision: { min: 0, max: 0 },
                                              valueRange: { min: 0, max: 5000000 }
                                            }"
                                            name="grossIncome"
                                            label="Enter amount"
                                            placeholder="Enter amount per year"
                                            :isRequired="typeOfBond === 1"
                                            requiredDescription="Please enter a value in this field."
                                            requiredMessage="Please enter a value in this field."
                                            :addSuffix="true"
                                            suffixText="per year"
                                          />
                                        </MDBCol>
                                      </MDBRow>
                                    </MDBCol>
              
                                    <MDBCol 
                                      lg="6" 
                                      class="pt-3 pt-lg-0"
                                      v-if="typeOfBond === 1"
                                    >
                                      <MDBRow>
                                        <MDBCol>
                                          <div class="form-group">
                                            <label for="investmentTerm" class="main-label" tabindex="0">
                                              Investment term
                                            </label>
                                          </div>
                                        </MDBCol>
                                      </MDBRow>
                                      
                                      <MDBRow>
                                        <MDBCol>
                                          <NumInput
                                            v-model.number.lazy="investmentTerm"
                                            divClass=""
                                            cssClass="input"
                                            :options="{
                                              precision: { min: 0, max: 0 },
                                              currencyDisplay: 'hidden',
                                              valueRange: { min: 10, max: 40 }
                                            }"
                                            name="investmentTerm"
                                            label="Enter amount"
                                            placeholder="Enter amount"
                                            :isRequired="true"
                                            requiredDescription="Please enter a value in this field."
                                            requiredMessage="Please enter a value in this field."
                                          />
              
                                          <small class="pt-2" v-if="investmentTerm > 0">
                                            <em>Between 10 and 40 years</em>
                                          </small>
                                        </MDBCol>
                                      </MDBRow>
                                    </MDBCol>
              
                                    <MDBCol 
                                      lg="6" 
                                      class="pt-3 pt-lg-0" 
                                      v-if="typeOfBond === 1 && this.extraContributions > 0"
                                    >
                                      <MDBRow>
                                        <MDBCol>
                                          <div class="form-group">
                                            <label for="extraContributionsRateOfIncrease" class="main-label" tabindex="0">
                                              How much would you like to increase your extra contributions by (per year)
                                            </label>
                                          </div>
                                        </MDBCol>
                                      </MDBRow>
              
                                      <MDBRow>
                                        <MDBCol>
                                          <select
                                            v-model="extraContributionsRateOfIncrease"
                                            class="form-select form-control"
                                            name="extraContributionsRateOfIncrease"
                                            id="extraContributionsRateOfIncrease"
                                            :required="true"
                                          >
                                            <option :value="0">0%</option>
                                            <option :value="0.05">5%</option>
                                            <option :value="0.10">10%</option>
                                            <option :value="0.15">15%</option>
                                            <option :value="0.20">20%</option>
                                            <option :value="0.25">25%</option>
                                          </select>
                                        </MDBCol>
                                      </MDBRow>
                                    </MDBCol>
              
                                    <MDBCol 
                                      lg="6" 
                                      class="pt-3 pt-lg-0" 
                                      v-if="typeOfBond === 2"
                                    >
                                      <MDBRow>
                                        <MDBCol>
                                          <div class="form-group">
                                            <label for="requiredFuneralFund" class="main-label" tabindex="0">
                                              Required funeral fund
              
                                              <!-- <ToolTip text="This value needs some more explanation">
                                                <span class="icon-info"></span>
                                              </ToolTip> -->
                                            </label>
                                          </div>
                                        </MDBCol>
                                      </MDBRow>
                                      
                                      <MDBRow>
                                        <MDBCol>
                                          <NumInput
                                            v-model.number.lazy="requiredFuneralFund"
                                            divClass=""
                                            cssClass="input"
                                            :options="{
                                              precision: { min: 0, max: 0 },
                                              valueRange: { min: 0, max: 30000 },
                                            }"
                                            name="requiredFuneralFund"
                                            label="Enter amount"
                                            placeholder="Enter amount"
                                            :isRequired="typeOfBond === 2"
                                            requiredDescription="Please enter a value in this field."
                                            requiredMessage="Please enter a value in this field."
                                          />
                                        </MDBCol>
                                      </MDBRow>
                                    </MDBCol>
              
                                    <MDBCol 
                                      lg="6" 
                                      class="pt-3 pt-lg-0"
                                      v-if="typeOfBond === 2"
                                    >
                                      <MDBRow>
                                        <MDBCol>
                                          <div class="form-group">
                                            <label for="targetSavingDuration" class="main-label" tabindex="0">
                                              Target saving duration
              
                                              <!-- <ToolTip text="Replace this with appropriate text">
                                                <span class="icon-info"></span>
                                              </ToolTip> -->
                                            </label>
                                          </div>
                                        </MDBCol>
                                      </MDBRow>
                                      
                                      <MDBRow>
                                        <MDBCol>
                                          <NumInput
                                            v-model.number.lazy="targetSavingDuration"
                                            divClass="rhs"
                                            cssClass="input"
                                            :options="{
                                              precision: { min: 0, max: 0 },
                                              valueRange: { min: 5, max: 20 },
                                              currencyDisplay: 'hidden',
                                            }"
                                            name="targetSavingDuration"
                                            label="Enter amount"
                                            placeholder="Enter number of years"
                                            :isRequired="typeOfBond === 2"
                                            requiredDescription="Please enter a value in this field."
                                            requiredMessage="Please enter a value in this field."
                                            :addSuffix="true"
                                            suffixText="years"
                                          />
                                        </MDBCol>
                                      </MDBRow>
                                    </MDBCol>
              
                                    <MDBCol lg="6" class="mt-4 mt-lg-0">
                                      <MDBRow>
                                        <MDBCol>
                                          <div class="form-group">
                                            <label for="startingDeposit" class="main-label" tabindex="0">
                                              Starting deposit
                                            </label>
                                          </div>
                                        </MDBCol>
                                      </MDBRow>
                                      
                                      <MDBRow>
                                        <MDBCol>
                                          <NumInput
                                            v-model.number.lazy="startingDeposit"
                                            divClass=""
                                            cssClass="input"
                                            :options="{
                                              precision: { min: 0, max: 0 },
                                              valueRange: { min: startingDepositMinimum, max: startingDepositMaximum }
                                            }"
                                            name="startingDeposit"
                                            label="Enter amount"
                                            placeholder="Enter amount per year"
                                            :isRequired="true"
                                            requiredDescription="Please enter a value in this field."
                                            requiredMessage="Please enter a value in this field."
                                          />
              
                                          <small class="pt-2">
                                            <em>Between ${{ $formatCurrency(startingDepositMinimum) }} and ${{ $formatCurrency(startingDepositMaximum) }}.</em>
                                          </small>
              
                                          <small class="warning" v-if="typeOfBond === 2 && startingDeposit > 14000">
                                            <em>Your age pension may be impacted if your total funeral bond exceeds $14,000.</em>
                                          </small>
                                        </MDBCol>
                                      </MDBRow>
                                    </MDBCol>
              
                                    <MDBCol lg="6" class="mt-4 mt-lg-0">
                                      <MDBRow>
                                        <MDBCol>
                                          <div class="form-group">
                                            <label for="investmentRisk" class="main-label" tabindex="0">
                                              Investment risk
                                            </label>
                                          </div>
                                        </MDBCol>
                                      </MDBRow>
              
                                      <MDBRow>
                                        <MDBCol>
                                          <div class="form-floating mb-4 mb-lg-3">
                                            <select
                                              v-model="investmentRisk"
                                              class="form-select form-control"
                                              name="investmentRisk"
                                              id="investmentRisk"
                                              :required="true"
                                            >
                                              <option value="">Please select</option>
                                              <option
                                                v-for="(option, index) in availableInvestmentOptions"
                                                :key="index"
                                                :value="option.value"
                                              >
                                                {{ option.label }}
                                              </option>
                                            </select>
              
                                            <!-- <label for="investmentRisk" v-if="investmentRisk != ''">
                                              Frequency
                                            </label> -->
              
                                            <div 
                                              class="invalid-feedback" 
                                              aria-live="assertive" 
                                              aria-description="Please select one of the options."
                                            >
                                              Please select one of the options.
                                            </div>
                                          </div>
                                        </MDBCol>
                                      </MDBRow>
                                    </MDBCol>
                                  </MDBRow>
              
                                  <MDBRow>
                                    <MDBCol class="pt-3 text-center d-print-none">
                                      <small>
                                        <a href="javascript:;" @click="accordion.one = null">Close fine tuning</a>
                                      </small>
                                    </MDBCol>
                                  </MDBRow>
                                    
                                </MDBAccordionItem>
                              </MDBAccordion>
                            </div>
                          </div>
                        </MDBCol>
                      </MDBRow>

              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>

        

        

        <!-- Print only display -->
        <div class="d-none d-print-block page-break-before">
          <div v-html="clientConfig.content.disclaimer.content"></div>
          <h5 class="page-break-before extra-margin">Assumptions</h5>
          <MDBTable class="assumptions">
            <tbody>
              <tr>
                <th>Wage Inflation</th>
                <td>{{ this.wageInflation }}%</td>
              </tr>
              <tr>
                <th>Price inflation</th>
                <td>{{ this.priceInflation }}%</td>
              </tr>
              <tr>
                <th>Fees (no cap)</th>
                <td>{{ this.assetFee }}%</td>
              </tr>
            </tbody>
          </MDBTable>
          <MDBTable v-if="userDefinedInvestment != ''" class="assumptions">
            <tbody>
              <tr>
                <th>Total return (p.a)</th>
                <td>{{ this.customInvestmentReturnRate }}%</td>
              </tr>
            </tbody>
          </MDBTable>
          
        </div>

        <!-- End print only display -->

        <MDBRow class="mt-5 d-print-none">
          <MDBCol md="11" class="mx-auto text-center">
            <MDBBtn
              color="primary"
              class="btn-primary print"
              @click="printResults()"
              aria-label="Print"
            >
              Print
            </MDBBtn>
          </MDBCol>
        </MDBRow>

      </MDBCol>
    </MDBRow>
  </MDBContainer>

  <MDBContainer fluid class="px-md-5">
    <MDBRow class="px-2">
      <MDBCol md="11" class="main-nav-wrapper">
        <MDBRow>
          <MDBCol md="11" class="mt-3 mb-4 text-center text-sm-start">
            <MDBBtn
              class="btn-primary back mb-3 mx-3 ms-sm-0 mb-3 mb-sm-0 d-print-none"
              @click="clickToTab(3)"
              aria-label="Back button"
            >
              Back
            </MDBBtn>

            <MDBBtn
              class="btn-primary mb-3 mx-3 me-sm-0 mb-sm-0 d-print-none"
              @click="clickToTab(5)"
              aria-label="Continue button"
            >
              Next steps
            </MDBBtn>
          </MDBCol>
        </MDBRow>
      </MDBCol>

      <MDBCol>
        <MDBRow>
          <MDBCol col="6" class="mx-auto mt-3 mb-4 text-center text-sm-start d-print-none">
            <a href="javascript:;" class="icon-restart" @click="resetModeller">Reset tool</a>
          </MDBCol>

          <MDBCol col="6" class="mx-auto mt-3 mb-4 text-center text-sm-end d-print-none">
            <a href="javascript:;" class="icon-edit" @click="clickToTab(7)">Edit assumptions</a>
          </MDBCol>
        </MDBRow>
      </MDBCol>
    </MDBRow>
  </MDBContainer>
</template>
